'use client';

import { useFunnelSideEffects } from '../../model/in-funnel/side-effects';

/** Runs the funnel's side effects once per step page; renders nothing. */
export function FunnelSideEffects() {
  useFunnelSideEffects();
  return null;
}